import { useEffect, useState } from 'react'
import ReactLoading from 'react-loading'
import animationStyle from './loginAnimation.module.css'

const APPLE_SERVICE_ID = process.env.REACT_APP_APPLE_SERVICE_ID || ''
const APPLE_REDIRECT_URI =
    process.env.REACT_APP_APPLE_REDIRECT_URI ||
    window.location.origin + '/login'
const BACKEND_URL = process.env.REACT_APP_API_BASE

function AppleLoginBtn(props) {
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        // Load the Apple Sign-In JS SDK
        if (document.getElementById('apple-signin-sdk')) return
        const script = document.createElement('script')
        script.id = 'apple-signin-sdk'
        script.src =
            'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js'
        script.async = true
        script.onload = () => {
            if (window.AppleID && APPLE_SERVICE_ID) {
                window.AppleID.auth.init({
                    clientId: APPLE_SERVICE_ID,
                    scope: 'name email',
                    redirectURI: APPLE_REDIRECT_URI,
                    usePopup: true, // no page redirect — result comes back via JS
                })
            }
        }
        document.body.appendChild(script)
    }, [])

    const handleAppleSignIn = async () => {
        if (!window.AppleID) {
            alert('Apple Sign-In is not available yet, please try again.')
            return
        }
        try {
            setIsLoading(true)
            const response = await window.AppleID.auth.signIn()
            /*
             * response.authorization.id_token — the identity token
             * response.user (only on first login) — { name: { firstName, lastName }, email }
             */
            const identityToken = response.authorization.id_token
            const fullName = response.user?.name
                ? {
                      givenName: response.user.name.firstName || '',
                      familyName: response.user.name.lastName || '',
                  }
                : null

            const res = await fetch(`${BACKEND_URL}/api/auth/apple`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ identityToken, fullName }),
            })

            if (res.ok) {
                const { token } = await res.json()
                localStorage.setItem('userJWT', token)
                // Store what name/email Apple gave (only available on first login)
                if (response.user?.email) {
                    sessionStorage.setItem(
                        'userData_email',
                        response.user.email
                    )
                    localStorage.setItem('user_email', response.user.email)
                }
                if (response.user?.name) {
                    const name =
                        `${response.user.name.firstName || ''} ${response.user.name.lastName || ''}`.trim()
                    sessionStorage.setItem('userData_name', name)
                }
                props.history.push('/kitSelection')
            } else {
                const err = await res.json()
                console.error('Apple login backend error:', err)
                alert('Apple Sign-In failed. Please try again.')
            }
        } catch (err) {
            // User cancelled or SDK error — don't alert on cancellation
            if (err?.error !== 'popup_closed_by_user') {
                console.error('Apple Sign-In error:', err)
                alert('Apple Sign-In failed. Please try again.')
            }
        } finally {
            setIsLoading(false)
        }
    }

    if (!APPLE_SERVICE_ID) return null

    return isLoading ? (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '4px',
            }}
        >
            <ReactLoading type="spin" color="white" height={40} width={40} />
        </div>
    ) : (
        <button className={animationStyle.appleBtn} onClick={handleAppleSignIn}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="18"
                height="18"
                fill="currentColor"
                style={{ marginRight: '14px' }}
            >
                <path d="M16.365 1.43c0 1.14-.42 2.24-1.18 3.07-.8.87-2.1 1.54-3.3 1.44-.16-1.1.42-2.27 1.2-3.06.86-.9 2.24-1.56 3.28-1.45zM21.56 17.03c-.47 1.05-.7 1.52-1.3 2.47-.84 1.34-2.02 3.02-3.5 3.03-1.32.02-1.66-.85-3.46-.84-1.8.01-2.18.86-3.5.85-1.48-.01-2.6-1.5-3.44-2.84-2.34-3.66-2.58-7.94-1.15-10.1.99-1.5 2.55-2.38 4.01-2.38 1.49 0 2.42.86 3.64.86 1.18 0 1.9-.86 3.63-.86 1.3 0 2.68.71 3.67 1.94-3.24 1.78-2.72 6.4.4 7.87z" />
            </svg>
            Sign in with Apple
        </button>
    )
}

export default AppleLoginBtn
